import gql from 'graphql-tag';
import get from 'lodash/get';
import dayjs from 'dayjs';
import { compose, graphql } from 'react-apollo';
import uuid from 'uuid/v4';
import { createContact, listContacts } from '../../graphql/custom/contacts';
import { GetJob } from '../../graphql/custom/jobs';
import { createReferral } from '../../graphql/custom/referrals';

export const withCreateReferral = (Component) => {
	return compose(
		graphql(gql(createReferral), {
			props: (props) => ({
				onCreateReferral(input) {
					const optimisticResponseData = {
						...input.input,
						id: uuid(),
						referralDate: dayjs(),
					};
					props.mutate({
						context: {
							headers: {
								'x-frame-options': 'deny', // This header will reach the server
							},
						},
						variables: input,
						optimisticResponse: {
							__typeName: 'Mutation',
							createReferral: {
								__typeName: 'createReferral',
								...optimisticResponseData,
							},
						},
						update(proxy, { data: { createReferral: newReferral } }) {
							try {
								const data = proxy.readQuery({
									query: GetJob,
									variables: {
										id: get(
											props,
											['ownProps', 'jobData', 'id'],
											get(props, ['ownProps', 'job', 'id'], [])
										),
									},
								});
								if (data.GetJob) {
									const referrals = get(data, 'GetJob.referrals', []);
									const hasReferralBeenCached = referrals.find((referral) => {
										return newReferral ? referral.id === newReferral.id : false;
									});

									if (!hasReferralBeenCached) {
										referrals.push(newReferral);

										proxy.writeQuery({
											query: GetJob,
											variables: {
												filter: {
													id: get(
														props,
														['ownProps', 'jobData', 'id'],
														get(props, ['ownProps', 'job', 'id'], [])
													),
												},
											},
											referrals,
											data,
										});
									}
								}
							} catch {
								// ignore
							}
						},
					});
				},
			}),
		}),
		graphql(gql(createContact), {
  props: (props) => ({
    ImportedCreateContact(input) {
      const optimisticResponseData = {
        id: uuid(),
        ...input.input,
        referrals: null,
        __typename: 'Contact',
      };
      return props.mutate({
        context: {
          headers: {
            'x-frame-options': 'deny',
          },
        },
        variables: input,
        optimisticResponse: {
          __typename: 'Mutation',
          createContact: {
            __typename: 'createContact',
            ...optimisticResponseData,
          },
        },
        update(proxy, { data: { createContact } }) {
          try {
            const data = proxy.readQuery({
              query: gql(listContacts),
              variables: {
                filter: {
                  userId: { eq: props.ownProps.currentUser.id },
                },
                limit: 5000,
                nextToken: null,
              },
            });

            // Check if data exists and listContacts is not null
            if (!data || !data.listContacts || !data.listContacts.items) {
              console.warn('listContacts query returned null or no items');
              return;
            }

            // Check if contact already exists before adding
            if (!data.listContacts.items.find(
              (contact) => contact.id === createContact.id
            )) {
              data.listContacts.items.push(createContact);
              
              // Write back to cache
              proxy.writeQuery({
                query: gql(listContacts),
                context: {
                  headers: {
                    'x-frame-options': 'deny',
                  },
                },
                variables: {
                  filter: {
                    userId: { eq: props.ownProps.currentUser.id },
                  },
                  limit: 5000,
                  nextToken: null,
                },
                data,
              });
            }
          } catch (error) {
            // Handle case where query doesn't exist in cache yet
            console.warn('Could not update cache after mutation:', error);
            // Optionally, you could refetch the query here
            // or just let it be handled by the next query
          }
        },
      });
    },
  }),
})
	)(Component);
};